<template>
  <div class="header" :class="{ whiteHeader: topOffect > 50 }">
    <div class="logo">
      <div class="logo_img"><img src="@/assets/image/phone/z10603_1.png" style="height: 6vh"></img></div>
      <!--<div>清耳话声</div>-->
    </div>
    <div style="display: flex;align-items: center;">
      <van-button icon="http://admin.qingerhuasheng.com/search/table.png" @click="show()"
        style="margin-right: 10px;" size="small" round color="#733d9a">
        耳鸣测评
      </van-button>
      <van-popover 
        placement="left-start" 
        v-model="showPopover" 
        trigger="click" 
        style="line-height:0" 
        :actions="actions"
        @select="onSelect">
        <template #reference>
          <van-button icon="http://admin.qingerhuasheng.com/search/menu.png"
            style="background: transparent;border-color: transparent;border:0px;padding-right: 0px">
          </van-button>
        </template>
      </van-popover>
    </div>
    <el-dialog title="选择量表" :visible.sync="dialogTableVisible" width="80%" :append-to-body="true">
      <van-cell is-link @click="goMeasure(2)">
        <template #title>
          <span class="custom-title">耳鸣功能指数量表（TFI）</span>
        </template>
      </van-cell>
      <van-cell is-link @click="goMeasure(1)">
        <template #title>
          <span class="custom-title">耳鸣致残量表（THI）</span>
        </template>
      </van-cell>
      <van-cell is-link @click="goMeasure(4)">
        <template #title>
          <span class="custom-title">耳鸣声响和烦躁程度量表（VAS）</span>
        </template>
      </van-cell>
      <van-cell is-link @click="goMeasure(3)">
        <template #title>
          <span class="custom-title">耳鸣评价量表（TEQ）</span>
        </template>
      </van-cell>
    </el-dialog>
  </div>

</template>


<script>
import deviceAdapter from '@/mixins/deviceAdapter'
import navigationFixed from '@/mixins/navigationFixed'
export default {
  mixins: [deviceAdapter, navigationFixed],
  name: "phoneHead",
  data() {
    return {
      dialogTableVisible: false,
      showPopover: false,
      actions: [
        { text: '首页' },
        { text: '专业技术' },
        { text: '产品中心' },
        { text: '用户中心' },
        { text: '企业新闻' },
        { text: '名家新作' },
        { text: '听觉名医录' },
        { text: '关于我们' },
        { text: '个人中心' }
      ],
      showFocus: false,
      scene: 5,
      deviceRow: {}
    };
  },
  created() {
    this.flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    // this.getWechatCode()
  },
  methods: {
    show() {
      this.dialogTableVisible = true
    },
    isWechat() {
      return (
        String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
        "micromessenger"
      );
    },
    goMeasure(category) {
      if(!this.$store.state.customer.customerInfo.mobile){
        this.$router.push({ 
          name: 'phoneUserLogin' , 
          params:{'scene':1} 
        });
      }else{
        this.$router.push({
          name: 'measurement',
          query: {
            source: 3,
            category: category
          }
        })
      }
    }
  },
};
</script>

<style scoped>
.logo {
  display: flex;
  height: 8vh;
  font-size: 15px;
  align-items: center;
}

.logo>.logo_img {
  display: flex;
  height: 6vh;
  margin-right: 1vw;
  flex-direction: column;
  justify-items: center;
  justify-content: center;
}

.logo>img {
  width: 5vw;
  height: 5vh;
  /* line-height: 8vh; */
}

.header {
  width: 100vw;
  height: 8vh;
  background: rgba(255, 255, 255, 1);
  /* position: fixed; */
  top: 0;
  z-index: 20;
  padding: 0 3%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  line-height: 8vh;
}
</style>
